module.exports = __webpack_public_path__ + "01_short_gray.613a4abf.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/01_short_gray.png
// module id = Qoii
// module chunks = 0